import { createTheme } from "@mantine/core";
import '../../assets/base.css';const baseTheme = createTheme({
  cursorType: "pointer",
  black: "#000000",
  white: "#ffffff",
  fontFamily: "Montserrat, sans-serif",
  headings: {
    fontFamily: "Montserrat, sans-serif"
  },
  breakpoints: {
    xs: "36em",
    // 576px
    sm: "48em",
    // 768px
    md: "62em",
    // 992px
    lg: "75em",
    // 1200px
    xl: "88em"
    // 1408px
  },
  other: {
    secondaryFont: "FS Renaissance",
    fontWeights: {
      regular: 400,
      semibold: 500,
      bold: 600
    },
    iconSizes: {
      xs: "1.125em",
      sm: "1.375em",
      md: "1.75em",
      lg: "2.125em",
      xl: "2.75em"
    },
    zIndex: {
      sub: -1,
      none: 0,
      page: 1,
      header: 100,
      modal: 200
    }
  }
});
export {
  baseTheme
};
